<template>
  <div>
    <!-- <div class="d-flex justify-content-center mb-4">
      <button type="button" class="link-white xxxsmall ls-15 mx-2" :class="{'active': carousel==='services'}" @click="selectCarousel('services')">SERVICES</button>
      <button type="button" class="link-white xxxsmall ls-15 mx-2" :class="{'active': carousel==='products'}" @click="selectCarousel('products')">PRODUCTS</button>
    </div> -->

    <div class="bg-white-10 skew-sm-30 skew-15 my-4 py-4 px-xl-18 px-lg-14 px-sm-10 px-5">
      <div class="bg-white-20 skew-inner py-4 px-sm-10 px-6">
        <div class="row justify-content-center">
          <div class="col-16">
            <swiper ref="swiper" :options="swiperOptions" class="exclusivities-carousel">
              <swiper-slide v-for="(slide, index) in slides" :key="index">
                <img :src="slide" :alt="slide">
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    Swiper,
    Autoplay
  } from 'swiper'

  import VueAwesomeSwiper from 'vue-awesome-swiper'

  Swiper.use([Autoplay])
  Vue.use(VueAwesomeSwiper)

  export default {
    props: {
      services: {
        type: Array,
        required: true,
        default: null
      },
      products: {
        type: Array,
        required: false,
        default: null
      },
    },
    data() {
      return {
        carousel: 'services',
        swiperOptions: {
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          speed: 2000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            768: {
              slidesPerView: 2
            },
            576: {
              slidesPerView: 1
            }
          }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.swiper.$swiper
      },
      slides() {
        return this[this.carousel]
      }
    },
    methods: {
      selectCarousel(value) {
        this.carousel = value
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/sass/variables';
  @import 'node_modules/bootstrap/scss/vendor/rfs';

  .exclusivities-carousel {
    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
      position: relative;

      img {
        max-width: 125px;
        max-height: 38px;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        background: rgba($white, 0.2);
        height: 100%;
        width: 1px;
      }
    }
  }

  // MD
  @media only screen and (max-width: 767px) {
    .exclusivities-carousel {
      .swiper-slide {
        &::after {
          content: unset;
        }
      }
    }
  }

  // SM
  @media only screen and (max-width: 576px) {
    .exclusivities-carousel {
      .swiper-slide {
        padding: 0px 5px;
      }
    }
  }
</style>